export default __webpack_public_path__ + "static/media/foot-right-back.e8a36d3e.png";